import { useState, useEffect } from 'react';

const useIsKeyboardFocus = (ref) => {
  const [isKeyboardFocus, setIsKeyboardFocus] = useState(false);

  useEffect(() => {
    const handleKeyDown = () => setIsKeyboardFocus(true);
    const handleMouseDown = () => setIsKeyboardFocus(false);

    const element = ref.current;

    if (element) {
      element.addEventListener('keydown', handleKeyDown);
      element.addEventListener('mousedown', handleMouseDown);
    }

    return () => {
      if (element) {
        element.removeEventListener('keydown', handleKeyDown);
        element.removeEventListener('mousedown', handleMouseDown);
      }
    };
  }, [ref]);

  return isKeyboardFocus;
};

export default useIsKeyboardFocus;
